import React, { useState, useEffect } from "react";
import moment from "jalali-moment"; // برای تاریخ شمسی
import momentTimezone from "moment-timezone"; // برای تبدیل تایم زون
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import { useNavigate } from 'react-router-dom';
import "react-big-calendar/lib/css/react-big-calendar.css";
import axios from 'axios';
import apiConfig from "../config/apiConfig"; 
import "../assets/css/customcss.css";
import { ToastContainer, toast } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css"; 
import Swal from "sweetalert2";

// استفاده از moment-timezone برای localizer با تایم زون America/Winnipeg
const localizer = momentLocalizer(momentTimezone);

function Reservations() {
  const [reservations, setReservations] = useState([]); // رزروها برای نمایش در تقویم
  const [selectedDayReservations, setSelectedDayReservations] = useState([]); // رزروهای روز انتخابی
  const [calendarView, setCalendarView] = useState("month"); // نمای تقویم
  const [selectedDate, setSelectedDate] = useState(new Date()); // تاریخ انتخابی
  const [loading, setLoading] = useState(false); // حالت لودینگ
  const navigate = useNavigate();
  const serverUrl = apiConfig.serverUrl;

  // اضافه کردن state برای نظرات
// const [surveys, setSurveys] = useState([]);

// // دریافت نظرات جلسات اتمام‌یافته
// useEffect(() => {
//   setLoading(true);
//   axios
//     .get(`${serverUrl}surveys/completed`)
//     .then((response) => {
//       if (response.data.status) {
//         setSurveys(response.data.surveys);
//       } else {
//         toast.error("خطا در دریافت نظرات.");
//       }
//     })
//     .catch((error) => {
//       console.error("خطا در دریافت نظرات: ", error);
//       toast.error("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
//     })
//     .finally(() => setLoading(false));
// }, []);

  // دریافت رزروها از سرور بر اساس تاریخ انتخاب شده
  useEffect(() => {
    if (selectedDate) {
      const selectedDateString = moment(selectedDate).format("jYYYY/jMM/jDD");
      const Usertoken = {
        headers: {
          selectedDate: selectedDateString,
        },
      };

      setLoading(true); // فعال کردن لودینگ
      axios
        .get(serverUrl + "get-users-reservations2", Usertoken)
        .then((response) => {
          // تبدیل رزروها به فرمت مناسب برای تقویم
          const events = response.data.ListUserReservations.map((reservation) => {
          // تبدیل تاریخ شمسی به میلادی
          const jalaliDate = moment(reservation.date, "jYYYY/jMM/jDD");
          const gregorianDate = jalaliDate.format("YYYY-MM-DD");
          
          // ساخت تاریخ و زمان کامل
          const dateTimeString = `${gregorianDate} ${reservation.time}`;
          
          // دریافت تایم زون کاربر از reservation (که از جدول users می‌آید)
          const userTimezone = reservation.timezone || 'Asia/Tehran';
          
          // مهم: تایم در دیتابیس به عنوان تایم در America/Winnipeg ذخیره شده است
          // اما کاربر آن را در تایم زون خودش انتخاب کرده است
          // پس باید تایم را به عنوان تایم در تایم زون کاربر تفسیر کنیم
          // و سپس به America/Winnipeg تبدیل کنیم
          
          // ابتدا تاریخ و زمان را در تایم زون کاربر می‌سازیم
          const userMoment = momentTimezone.tz(dateTimeString, "YYYY-MM-DD HH:mm:ss", userTimezone);
          
          // سپس به تایم زون America/Winnipeg تبدیل می‌کنیم
          const winnipegMoment = userMoment.clone().tz("America/Winnipeg");
          
          const startDate = winnipegMoment.toDate();
          const endDate = winnipegMoment.clone().add(1, "hours").toDate();
            
            return {
              id: reservation.id,
              title: `${reservation.user}`, // نام کاربر
              start: startDate, // زمان شروع (تبدیل شده به تایم زون America/Winnipeg)
              end: endDate, // زمان پایان (یک ساعت بعد)
              allDay: false, // رویداد تمام روز نیست
              userId: reservation.userid,
              status: reservation.status,
              originalTime: reservation.time, // ذخیره تایم اصلی برای نمایش
              originalDate: reservation.date // ذخیره تاریخ اصلی برای نمایش
            };
          });
          setReservations(events); // ذخیره رزروها برای تقویم
        })
        .catch((error) => {
          console.error("خطا در دریافت رزروها: ", error);
        })
        .finally(() => setLoading(false)); // غیرفعال کردن لودینگ
    }

   
  }, [selectedDate]);
  
 
  useEffect(() => {
    const addPersianDate = () => {
      const dateCells = document.querySelectorAll(".rbc-date-cell"); // سلول‌های مربوط به روزها
      dateCells.forEach((cell) => {
        const dateText = cell.innerText.trim(); // متن عدد میلادی
        if (dateText) {
          const persianDate = moment(dateText, "D").locale("fa").format("jD"); // تبدیل به شمسی

          // جلوگیری از تکرار اضافه کردن عدد شمسی
          if (!cell.querySelector(".persian-date")) {
            const persianDateSpan = document.createElement("span");
            persianDateSpan.className = "persian-date";
            persianDateSpan.style.color = "green"; // تغییر رنگ به سبز
            persianDateSpan.style.fontSize = "0.8em"; // تنظیم اندازه
            persianDateSpan.style.display = "block"; // نمایش تاریخ شمسی در خط جدید
            persianDateSpan.style.marginTop = "5px"; // فاصله بین تاریخ میلادی و شمسی
            persianDateSpan.innerText = persianDate;
            cell.appendChild(persianDateSpan); // اضافه کردن تاریخ شمسی زیر تاریخ میلادی
          }
        }
      });
    };

    setTimeout(addPersianDate, 0); // فراخوانی برای تاریخ شمسی
  }, [selectedDate]); 


 
  
  
  
  
  
  
  
  
  // متد جدید برای اتمام مشاوره
const completeReservation = (reservationId, reservationTime, reservationDate, userName) => {
  Swal.fire({
    title: "آیا مطمئن هستید؟",
    text: `آیا می‌خواهید مشاوره ساعت ${reservationTime} روز ${reservationDate} برای کاربر ${userName} به اتمام برسد؟`,
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "بله",
    cancelButtonText: "خیر",
  }).then((result) => {
    if (result.isConfirmed) {
      setLoading(true);
      const formData = new FormData();
      formData.append("id", reservationId);

      axios
        .post(`${serverUrl}complete-reservation`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.message) {
            toast.success("مشاوره با موفقیت به اتمام رسید!");
            setReservations((prevReservations) =>
              prevReservations.map((event) =>
                event.id === reservationId ? { ...event, status: "completed" } : event
              )
            );
          } else {
            toast.error("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
          }
        })
        .catch((error) => {
          console.error("خطا در اتمام مشاوره: ", error);
          toast.error("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
        })
        .finally(() => setLoading(false));
    }
  });
};



  // برای دریافت رزروهای روز انتخابی
  const loadSelectedDayReservations = (date) => {
    const selectedDateString = moment(date).format("jYYYY/jMM/jDD");
    const Usertoken = {
      headers: {
        selectedDate: selectedDateString,
      },
    };

    setLoading(true); // فعال کردن لودینگ
    axios
      .get(serverUrl + "get-users-reservations", Usertoken)
      .then((response) => {
        // فیلتر کردن رزروها برای روز انتخابی
        const selectedReservations = response.data.ListUserReservations.filter((reservation) => {
          const reservationDate = moment(reservation.date, "jYYYY/jMM/jDD").format("jYYYY/jMM/jDD");
          const selectedDateFormatted = moment(date).format("jYYYY/jMM/jDD");
          return reservationDate === selectedDateFormatted;
        }).map((reservation) => {
          // تبدیل تاریخ شمسی به میلادی
          const jalaliDate = moment(reservation.date, "jYYYY/jMM/jDD");
          const gregorianDate = jalaliDate.format("YYYY-MM-DD");
          
          // ساخت تاریخ و زمان کامل
          // تایم ممکن است به فرمت HH:mm:ss یا HH:mm باشد
          const timeFormat = reservation.time && reservation.time.split(':').length === 3 
            ? "YYYY-MM-DD HH:mm:ss" 
            : "YYYY-MM-DD HH:mm";
          const dateTimeString = `${gregorianDate} ${reservation.time}`;
          
          // دریافت تایم زون کاربر (یا استفاده از Asia/Tehran به عنوان پیش‌فرض)
          const userTimezone = reservation.timezone || 'Asia/Tehran';
          
          // تبدیل از تایم زون کاربر به America/Winnipeg
          const userMoment = momentTimezone.tz(dateTimeString, timeFormat, userTimezone);
          const winnipegMoment = userMoment.clone().tz("America/Winnipeg");
          
          return {
            ...reservation,
            time: winnipegMoment.format("HH:mm"), // تبدیل تایم به تایم زون America/Winnipeg
            originalTime: reservation.time // ذخیره تایم اصلی
          };
        });

        setSelectedDayReservations(selectedReservations); // ذخیره رزروهای روز انتخابی
      })
      .catch((error) => {
        console.error("خطا در دریافت رزروهای روز: ", error);
      })
      .finally(() => setLoading(false)); // غیرفعال کردن لودینگ
  };

  const handleSelectSlot = (slotInfo) => {
    const selectedDate = moment(slotInfo.start).format("YYYY-MM-DD");
    console.log("تاریخ روز انتخابی:", selectedDate);
    setSelectedDate(slotInfo.start);
    setCalendarView("day"); // تغییر نمای تقویم به روز
    loadSelectedDayReservations(slotInfo.start); // بارگذاری رزروهای روز انتخابی
  };
  const handleEventClick = (event) => {
    // استفاده از useNavigate برای هدایت
    
    navigate('/rtl/rtl-get-user-info', { state: { userid: event.userId } });
  };
  

  const handleNavigate = (date) => {
    setSelectedDate(date);
  };

  

  const cancelReservation = (reservationId, reservationTime, reservationDate, userName) => {
    Swal.fire({
      title: 'آیا مطمئن هستید؟',
      text: `نوبت ساعت ${reservationTime} روز ${reservationDate} کاربر ${userName} لغو شود؟`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'بله',
      cancelButtonText: 'خیر',
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
  
        const formData = new FormData();
        formData.append("id", reservationId);
  
        axios
          .post(`${serverUrl}cancel-request-booking-panel`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (response.data.message) {
              toast.success('رزرو با موفقیت لغو شد!');
              setReservations((prevReservations) =>
                prevReservations.filter((event) => event.id !== reservationId)
              );
            } else {
              toast.error("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
            }
          })
          .catch((error) => {
            console.error("خطا در لغو رزرو: ", error);
            toast.error("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
          })
          .finally(() => setLoading(false));
      }
    });
  };
  
  

  
  const CustomAgendaEvent = ({ event }) => {
    const [survey, setSurvey] = useState(null);
    const [loadingSurvey, setLoadingSurvey] = useState(false);
  
    // دریافت نظر برای رزرو
    useEffect(() => {
      if (event.status === "completed") {
        setLoadingSurvey(true);
        axios
          .get(`${apiConfig.serverUrl}surveys/reservation/${event.id}`)
          .then((response) => {
            if (response.data.status) {
              setSurvey(response.data.survey);
            }
          })
          .catch((error) => {
            console.error("خطا در دریافت نظر: ", error);
          })
          .finally(() => setLoadingSurvey(false));
      }
    }, [event.id, event.status]);
  
    const getStatusIcon = (status) => {
      switch (status) {
        case "confirmed":
          return (
            <span title="تایید شده" style={{ marginLeft: "10px", color: "green", fontSize: "1.2em" }}>
              ✔️
            </span>
          );
        case "waiting":
          return (
            <span title="در حال انتظار" style={{ marginLeft: "10px", color: "orange", fontSize: "1.2em" }}>
              ⏳
            </span>
          );
        case "cancelled":
          return (
            <span title="لغو شده" style={{ marginLeft: "10px", color: "red", fontSize: "1.2em" }}>
              ❌
            </span>
          );
        case "completed":
          return (
            <span title="اتمام یافته" style={{ marginLeft: "10px", color: "blue", fontSize: "1.2em" }}>
              ✅
            </span>
          );
        default:
          return null;
      }
    };
  
    // نمایش نظر در پاپ‌آپ
    const showSurveyPopup = () => {
      if (loadingSurvey) {
        Swal.fire({
          title: "در حال بارگذاری...",
          text: "لطفاً منتظر بمانید تا نظر بارگذاری شود.",
          icon: "info",
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        return;
      }
  
      if (survey) {
        Swal.fire({
          title: "نظرات کاربر",
          html: `
            <div class="survey-popup-content">
              <p><strong>نام کاربر:</strong> ${survey.user_name}</p>
              <p><strong>امتیاز:</strong> ${survey.rating} / 5</p>
              <p><strong>نظر:</strong> ${survey.comment || "بدون نظر"}</p>
            </div>
          `,
          icon: "info",
          confirmButtonText: "بستن",
          customClass: {
            popup: "survey-popup",
            title: "survey-popup-title",
            content: "survey-popup-content",
            confirmButton: "survey-popup-button",
          },
        });
      } else {
        Swal.fire({
          title: "بدون نظر",
          text: "نظری برای این رزرو ثبت نشده است.",
          icon: "warning",
          confirmButtonText: "بستن",
          customClass: {
            popup: "survey-popup",
            title: "survey-popup-title",
            content: "survey-popup-content",
            confirmButton: "survey-popup-button",
          },
        });
      }
    };
  
    return (
      <div className="custom-agenda-event">
        <span>{event.title}</span>
        {getStatusIcon(event.status)}
        <button
          className="cancel-button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            // تبدیل تایم به تایم زون America/Winnipeg برای نمایش
            const winnipegMoment = momentTimezone.tz(event.start, "America/Winnipeg");
            cancelReservation(event.id, winnipegMoment.format("HH:mm"), winnipegMoment.format("jYYYY/jMM/jDD"), event.title);
          }}
          disabled={loading || event.status === "completed"}
          style={{
            marginLeft: "15px",
            padding: "5px 10px",
            background: "red",
            border: "1px solid #ccc",
            borderRadius: "5px",
            cursor: loading || event.status === "completed" ? "not-allowed" : "pointer",
          }}
        >
          لغو رزرو
        </button>
        <button
          className="complete-button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            // تبدیل تایم به تایم زون America/Winnipeg برای نمایش
            const winnipegTime = momentTimezone.tz(event.start, "America/Winnipeg");
            const winnipegDate = momentTimezone.tz(event.start, "America/Winnipeg");
            completeReservation(event.id, winnipegTime.format("HH:mm"), winnipegDate.format("jYYYY/jMM/jDD"), event.title);
          }}
          disabled={loading || event.status === "completed"}
          style={{
            marginLeft: "15px",
            padding: "5px 10px",
            background: "blue",
            color: "white",
            border: "1px solid #ccc",
            borderRadius: "5px",
            cursor: loading || event.status === "completed" ? "not-allowed" : "pointer",
          }}
        >
          اتمام مشاوره
        </button>
        {event.status === "completed" && (
          <button
            className="survey-button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              showSurveyPopup();
            }}
            disabled={loadingSurvey}
            style={{
              marginLeft: "15px",
              padding: "5px 10px",
              background: "green",
              color: "white",
              border: "1px solid #ccc",
              borderRadius: "5px",
              cursor: loadingSurvey ? "not-allowed" : "pointer",
            }}
          >
            نمایش نظر
          </button>
        )}
      </div>
    );
  };
  

  
  
  
  
  
  
  
  
  
  
  

  return (
    <>
    <ToastContainer />
      <div className="calendar-container" style={{maxWidth:'75%',marginRight:'20%',height:'100%'}}>
      <BigCalendar
      localizer={localizer}
      events={reservations}
      startAccessor="start"
      endAccessor="end"
      view={calendarView}
      onView={(view) => setCalendarView(view)}
      onNavigate={handleNavigate}
      defaultView="month"
      views={["month", "week", "day", "agenda"]}
      selectable
      onSelectSlot={handleSelectSlot}
      onSelectEvent={handleEventClick} // هدایت هنگام کلیک
      date={selectedDate}
      style={{ height: '100%' }}
      culture="en"
      formats={{
        timeGutterFormat: (date, culture, localizer) => {
          return momentTimezone.tz(date, "America/Winnipeg").format("h:mm A");
        },
        eventTimeRangeFormat: ({ start, end }, culture, localizer) => {
          const startWinnipeg = momentTimezone.tz(start, "America/Winnipeg");
          const endWinnipeg = momentTimezone.tz(end, "America/Winnipeg");
          return `${startWinnipeg.format("h:mm A")} – ${endWinnipeg.format("h:mm A")}`;
        },
        agendaTimeFormat: (date, culture, localizer) => {
          return momentTimezone.tz(date, "America/Winnipeg").format("h:mm A");
        },
        agendaTimeRangeFormat: ({ start, end }, culture, localizer) => {
          const startWinnipeg = momentTimezone.tz(start, "America/Winnipeg");
          const endWinnipeg = momentTimezone.tz(end, "America/Winnipeg");
          return `${startWinnipeg.format("h:mm A")} – ${endWinnipeg.format("h:mm A")}`;
        }
      }}
      messages={{
        today: "امروز",
        previous: "قبلی",
        next: "بعدی",
        month: "ماه",
        week: "هفته",
        day: "روز",
        date: "تاریخ",
        time: "زمان",
        event: "رویداد",
        noEventsInRange: "رویدادی برای نمایش وجود ندارد",
        agenda: "برنامه زمانی",
        showMore: (total) => `+ نمایش ${total} مورد بیشتر`,
        
      }}
      
      components={{
        agenda: {
          event: CustomAgendaEvent, // استفاده از کامپوننت سفارشی
        },
        
      }}
      
      
    />


      </div>

      {loading && <div>در حال بارگذاری...</div>} {/* نمایش لودینگ */}

      {/* نمایش رزروهای روز انتخاب شده */}
      {selectedDayReservations.length > 0 && (
        <div className="day-reservations-panel">
          <h3>رزروهای روز انتخاب شده</h3>
          <div className="reservations-list">
            {selectedDayReservations.map((reservation, index) => (
              <div key={index} className="reservation-item">
                <p>نام: {reservation.user}</p>
                <p>ساعت: {reservation.time}</p>
                <p>وضعیت: {reservation.status}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default Reservations;
